import { useContext } from "react";

import { FluidContext } from "../fluid.provider.js";

export const useFluid = () => {
  const context = useContext(FluidContext);

  if (context.__ctx_init === false || !context.sharedTree) {
    throw new Error("useFluid must be used within a FluidProvider");
  }

  return {
    ...context,
    sharedTree: context.sharedTree,
  };
};
